import { QueryClient } from '@tanstack/react-query'
import { baseConfig, retryConfig } from './queryConfig'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      ...baseConfig,
      retry: retryConfig,
    },
    mutations: {
      retry: 1,
    },
  },
})

export default queryClient;
